import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import React from 'react';
import makeAsyncScriptLoader from 'react-async-script';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';
import { selectFabric } from '../../actions/cart';
import {
    getActiveFabricId,
    getActiveFabricTitle,
    getFabrics,
} from '../../reducers/fabrics';
import { getMessage } from '../../reducers/i18n';
import FabricSelection from '../addtocart/FabricSelection';
import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';
import Heading from '../heading/Heading';
import InternalLink from '../InternalLink';
import ChildWrapper from '../styles/AddToCartChildWrapper';
import CartWrapper from '../styles/AddToCartWrapper';
import ContentWrapper from '../styles/ContentWrapper';
import PriceDisplay from './PriceDisplay';

const URL = '//cdn.foxycart.com/checkout.stoff.love/loader.js';

const StyledMedia = styled(CardMedia)` 
    height: ${props => props.theme.space[22]};
`;

const Wrapper = styled(ContentWrapper)`
    
        & h1, h2, h3, h4, h5, h6 {
            margin: ${props => props.theme.space[7]} 0;
        }
        
        & p {
          margin-bottom: ${props => props.theme.space[0]};
        }
        
        & .stolo-cart-item {
          margin-bottom: 1em;
        }
`;

const Divider = styled.div`
    margin: ${props => props.theme.space[12]};
`;

const ColorSwatchesCartForm = ( { fabricSelected, fabricId, fabricTitle, fabrics, cartButtonLabel } ) => {
    const handleFabricChange = value => {
        fabricSelected(value);
    };

    return (
        <Wrapper>
            <Heading
                level={2} text={<FormattedMessage
                id='HEADER_COLORSWATCHES_CART_FORM'
                description='Label of the color swatches cart form.'
                defaultMessage='Farbmuster bestellen'
            />}
            />
            <p>
                <FormattedMessage
                    id='TEXT_COLORSWATCH_FORM'
                    description='Text forcolorswatches form.'
                    defaultMessage='Die Farben auf Smartphone, Tablet oder PC sehen oft anders aus. Mit den fertig gedruckten Farben + Farbcode gehst Du auf Nummer sicher und bestimmst exakt den richtigen Farbton.'
                />
                &nbsp;
                <InternalLink
                    to={{ type: types.NAVIGATED_TO_FAQ_RECOLORING }}
                >
                    <FormattedMessage
                        id='LINKTEXT_FAQ_RECOLORING_COLORSWATCH_FORM'
                        description='Label for link text faq recoloring on colorswatches form.'
                        defaultMessage='Wie das genau geht, zeigen wir Dir hier...'
                    />
                </InternalLink>
            </p>
            <Card>
                <StyledMedia
                    image='https://d2k02hhj0n6fcf.cloudfront.net/images/colorswatch-small.jpg'
                    title='Musterpaket mit allen Stoff-Qualitäten'
                />
                <CardContent>
                    <Heading
                        level={2} text={<FormattedMessage
                        id='TITLE_SMALL_WATCHES'
                        description='Title of the small color swatches.'
                        defaultMessage='Musterpaket mit allen Stoff-Qualitäten.'
                    />}
                    />
                    <form
                        action='https://checkout.stoff.love/cart'
                        method='post'
                        acceptCharset='utf-8'
                    >
                        <CartWrapper>
                            <ChildWrapper>
                                <PriceDisplay amount={6.00} shippingIncluded/>
                                <SecondaryRaisedButton
                                    type='submit'
                                    value='add-to-cart'
                                    disabled={false}
                                    icon='shopping_cart'
                                    text={cartButtonLabel}
                                />
                            </ChildWrapper>
                            <div>
                                <input
                                    type='hidden' name='name'
                                    value='Musterpaket mit allen Stoff-Qualitäten.'
                                    key={'foxy1'}
                                />
                                <input
                                    type='hidden' name='price' value='5.0454'
                                    key={'foxy2'}
                                />
                                <input
                                    type='hidden' name='category'
                                    value='swatches' key={'foxy3'}
                                />
                                <input
                                    type='hidden' name='code'
                                    value='colorswatch-small-all' key={'foxy4'}
                                />
                            </div>
                        </CartWrapper>
                    </form>

                </CardContent>
            </Card>
            <Divider/>
            <Card>
                <StyledMedia
                    image='https://d2k02hhj0n6fcf.cloudfront.net/images/colorswatch-big.jpg'
                    title='Kleine Farbkarte mit 35 Farben'
                />
                <CardContent>
                    <Heading
                        level={2} text={<FormattedMessage
                        id='TITLE_LARGE_WATCHES'
                        description='Title of the large color swatches.'
                        defaultMessage='Große Farbkarte mit 448 Farben.'
                    />}
                    />

                    <form
                        action='https://checkout.stoff.love/cart'
                        method='post'
                        acceptCharset='utf-8'
                    >
                        <CartWrapper>
                            <FabricSelection
                                wrapper={ChildWrapper}
                                handleFabricChange={handleFabricChange}
                                fabrics={fabrics}
                                activeFabricId={fabricId}
                            />
                            <ChildWrapper>
                                <PriceDisplay amount={14.98} shippingIncluded/>
                                <SecondaryRaisedButton
                                    type='submit'
                                    value='add-to-cart'
                                    disabled={false}
                                    icon='shopping_cart'
                                    text={cartButtonLabel}
                                />
                            </ChildWrapper>
                            <div>
                                <input
                                    type='hidden' name='name'
                                    value={`Grosses Farbmuster ${fabricTitle}`}
                                    key={'foxy1'}
                                />
                                <input
                                    type='hidden' name='price' value='12.58824'
                                    key={'foxy2'}
                                />
                                <input
                                    type='hidden' name='category'
                                    value='swatches' key={'foxy3'}
                                />
                                <input
                                    type='hidden' name='code'
                                    value='colorswatch-big' key={'foxy4'}
                                />
                                <input
                                    type='hidden' name='fabric'
                                    value={fabricTitle} key={'foxy5'}
                                />
                                <input
                                    type='hidden' name='fabricId'
                                    value={fabricId} key={'foxy6'}
                                />
                            </div>
                        </CartWrapper>
                    </form>
                </CardContent>
            </Card>

        </Wrapper>
    );
};

const mapDispatchToProps = dispatch => (
    {
        fabricSelected: fabricId => dispatch(selectFabric(fabricId)),
    }
);

const makeMapStateToProps = initialState => {
    const fabrics = getFabrics(initialState);
    const mapStateToProps = state => (
        {
            fabricTitle: getActiveFabricTitle(state),
            fabricId: getActiveFabricId(state),
            cartButtonLabel: getMessage(state, 'CART_BUTTON_LABEL'),
            fabrics,
        }
    );
    return mapStateToProps;
};

const connectedColorSwatchesCartForm = connect(
    makeMapStateToProps,
    mapDispatchToProps,
)(
    ColorSwatchesCartForm);

const ColorSwatchesCartFormLoader = makeAsyncScriptLoader(
    connectedColorSwatchesCartForm, URL,
);

export default ColorSwatchesCartFormLoader;



// WEBPACK FOOTER //
// ./src/components/cartforms/ColorSwatchesCartForm.js